import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "resultsArea",
    "itemRow", "itemCheck", "itemQty", "itemToggle", "itemSubtotal",
    "submitButton", "totalRefund"
  ]

  // Search is now handled by the HTML form submission via Turbo

  toggleItem(event) {
    const checkbox = event.target
    const itemId = checkbox.dataset.itemId
    const row = this.itemRowTargets.find(r => r.dataset.itemId === itemId)
    const qtyInput = this.itemQtyTargets.find(i => i.dataset.itemId === itemId)
    const toggleInput = this.itemToggleTargets.find(i => i.dataset.itemId === itemId)

    if (checkbox.checked) {
      row.classList.add("returns-item--selected")
      qtyInput.disabled = false
      toggleInput.disabled = false
      // Calculate subtotal for this item
      this.calculateItemSubtotal(itemId)
    } else {
      row.classList.remove("returns-item--selected")
      qtyInput.disabled = true
      toggleInput.disabled = true
      this.setItemSubtotal(itemId, 0)
    }

    this.recalculateTotal()
  }

  updateQuantity(event) {
    const input = event.target
    const itemId = input.dataset.itemId
    const max = parseInt(input.dataset.maxQty)
    let value = parseInt(input.value) || 0

    // Clamp value
    if (value < 1) value = 1
    if (value > max) value = max
    input.value = value

    this.calculateItemSubtotal(itemId)
    this.recalculateTotal()
  }

  calculateItemSubtotal(itemId) {
    const qtyInput = this.itemQtyTargets.find(i => i.dataset.itemId === itemId)
    const unitPrice = parseFloat(qtyInput.dataset.unitPrice) || 0
    const quantity = parseInt(qtyInput.value) || 0
    const subtotal = quantity * unitPrice

    this.setItemSubtotal(itemId, subtotal)
  }

  setItemSubtotal(itemId, amount) {
    const subtotalEl = this.itemSubtotalTargets.find(s => s.dataset.itemId === itemId)
    if (subtotalEl) {
      subtotalEl.textContent = this.formatCurrency(amount)
    }
  }

  recalculateTotal() {
    let total = 0
    const checkedBoxes = this.itemCheckTargets.filter(cb => cb.checked)

    checkedBoxes.forEach(cb => {
      const itemId = cb.dataset.itemId
      const qtyInput = this.itemQtyTargets.find(i => i.dataset.itemId === itemId)
      if (qtyInput) {
        const unitPrice = parseFloat(qtyInput.dataset.unitPrice) || 0
        const quantity = parseInt(qtyInput.value) || 0
        total += quantity * unitPrice
      }
    })

    if (this.hasTotalRefundTarget) {
      this.totalRefundTarget.textContent = this.formatCurrency(total)
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = checkedBoxes.length === 0
    }
  }

  formatCurrency(amount) {
    return "$" + amount.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
}
